import { render } from "./Q3-Outtro.vue?vue&type=template&id=ecd6ee0e&scoped=true"
import script from "./Q3-Outtro.vue?vue&type=script&lang=js"
export * from "./Q3-Outtro.vue?vue&type=script&lang=js"

import "./Q3-Outtro.vue?vue&type=style&index=0&id=ecd6ee0e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecd6ee0e"]])

export default __exports__